export default __webpack_public_path__ + "static/O0225-3c8252c8805c6f349b5da04d5f98d5b8.png";